import { saveAs } from 'file-saver'

export const useDownloadFile = () => {
    const download = (data: Blob | ArrayBuffer | string, nameFile: string, contentType: string) => {
        const blob = data instanceof Blob ? data : new Blob([data], { type: contentType })
        saveAs(blob, nameFile)
    }

    return {
        download,
    }
}
